import { render, staticRenderFns } from "./saleBatchDetail.vue?vue&type=template&id=763ead7a&scoped=true&"
import script from "./saleBatchDetail.vue?vue&type=script&lang=js&"
export * from "./saleBatchDetail.vue?vue&type=script&lang=js&"
import style0 from "./saleBatchDetail.vue?vue&type=style&index=0&id=763ead7a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763ead7a",
  null
  
)

export default component.exports